<template>
  <div class="lms-wrapper-two">
    <div class="lms-content lms-content-full">
      <student-header
        ref="dnmchdr"
        class="filled"
        @toggle-navbar="toggleNavbar($event)"
        :navbarmode.sync="navbarMode"
      />
      <div
        class="lms-content-body lms-lesson-page pd-0-f"
        style="bottom: 0; height: calc(100vh - 90px)"
      >
        <div class="container-fluid">
          <div class="row">
            <div class="col-lg-3 lms-lesson-sidebar">
              <div class="">
                <nav-dynamic
                  @on-prev-next="lessonNextprev($event)"
                  @on-rebuy="onRebuy"
                  @on-course="course = $event"
                  ref="dnmcnav"
                >
                  <div
                    v-if="fillSidebarData.rdy"
                    class="mg-b-20 pd-y-20 pd-x-10 bd bd-1 bg-white rounded-10"
                  >
                    <fill-sidebar
                      :mode="fillSidebarData.mode"
                      :form="fillSidebarData.form"
                      :prms="fillSidebarData.prms"
                      @go-to-q="goToQ"
                    />
                  </div>
                </nav-dynamic>
              </div>
            </div>
            <div class="col-lg-9 col-md-12 lms-lesson-content">
              <div class="rounded-10 bg-white bd bd-1">
                <div
                  class=""
                  :style="
                    `min-height: calc(100vh - ${
                      mode == 4 ? '115' : '160'
                    }px); overflow-y: auto; max-height: 73vh;`
                  "
                >
                  <div v-if="mode == 0" class="pd-20">
                    <course-overview
                      @on-show-exam-result="showExamResult"
                      ref="crseovrvv"
                      :obj="course"
                      @show-attach="onAttach"
                      @on-attach="onAttach"
                      @on-modal-form-fill="onModalFormFill"
                      @on-view-lessons="shwCrseLessons()"
                    />
                  </div>
                  <div
                    v-else-if="mode == 2 || mode == 3"
                    :class="
                      `container container-fluid ${
                        $store.state.app.skin.dark ? '' : 'bg-white'
                      } ${
                        $store.state.app.isMobile || cntntNoPdn
                          ? 'pd-0-f mx-wd-100p-f'
                          : 'pd-25-f'
                      }`
                    "
                    :style="{
                      'max-width': cntntNoPdn ? '100% !important;' : 'inherit',
                    }"
                  >
                    <file-preview
                      ref="mediaMainPreview"
                      v-if="boxOt == 6 || boxOt == 286"
                      :id.sync="filePreview.id"
                      @on-completed-info="onCompletedInfo"
                      @on-file-loaded="onFileLoaded"
                      :params="$route.params"
                      @on-finish-video="onFinishVideo"
                      @on-hide-finish-btn="onHideFinish"
                      @content-no-padding="contentNoPadding"
                      @on-finished="attachOnFinished"
                      @on-interactive-media="showInteractiveMedia"
                      @on-interactive-html="showInteractiveHtml"
                      
                    />
                    <faq-detail
                      v-else-if="boxOt == 119 && taskObj.rdy"
                      :task.sync="taskObj.task"
                    />
                    <youtube-preview
                      v-else-if="boxOt == 122 && taskObj.rdy"
                      :url.sync="taskObj.task.taskDesc"
                    />
                    <embed-detail
                      v-else-if="boxOt == 422 && taskObj.rdy"
                      :task.sync="taskObj.task"
                    />
                    <html-detail
                      v-else-if="boxOt == 435 && taskObj.rdy"
                      :task.sync="taskObj.task"
                    />
                    <div
                      v-else-if="boxOt == 127 && taskObj.rdy"
                      class="pd-y-25 pd-x-20"
                    >
                      <a target="_blank" :href="taskObj.task.taskDesc">
                        <div class="d-flex align-items-center">
                          <feather
                            type="external-link"
                            class="wd-30-f ht-30-f mg-r-10"
                          ></feather>
                          <div>
                            <h6 class="tx-13 tx-color-02 tx-semibold mg-b-0">
                              {{ taskObj.task.task }}
                            </h6>
                            <span class="d-block tx-13 text-link-01">{{
                              taskObj.task.taskDesc
                            }}</span>
                          </div>
                        </div>
                      </a>
                    </div>

                    <img id="video2" />
                  </div>
                  <!-- sudalgaa survey fill -->
                  <form-fill
                    ref="frmFill"
                    v-if="
                      mode == 4 &&
                        (boxOt == 117 || boxOt == 416 || boxOt == 389)
                    "
                    @on-finish-form="onFinishForm"
                    @on-form-filled="onFormFilled"
                    :id="parseInt($route.params.iid, 10)"
                    :rightSideBar.sync="rightSideBar"
                    :boxId="parseInt($route.params.bid, 10)"
                    @on-toggle-class="
                      toggleBodyClass($event.mode, $event.class)
                    "
                    @on-reload="onReload"
                    :key="fillingFormKey"
                    :boxOt="parseInt($route.params.bot, 10)"
                    :prms="
                      lesson.boxes
                        .filter((x) => x.id == $route.params.bid)[0]
                        .forms.filter((f) => f.id == $route.params.iid)[0]
                    "
                    :course="courseInf"
                    class="mx-wd-100p-f"
                    @on-update-result-count="updateResultCount"
                    @lesson-exam-started="lessonExamStarted"
                    @form-page-rdy="cntntNoPdn = true"
                    @on-close-right-sidebar="toggleFillingSidebar"
                    :lessonDone="lesson.isDone"
                    @on-lesson-finish="lessonFinish()"
                    @nav-dynamic-update="navDynamicUpdate"
                    @on-fetch-sidebar="fillSidebarData = $event"
                  ></form-fill>
                </div>

                <div
                  class="bg-light d-flex justify-content-between align-items-center pd-x-10 pd-y-10 wd-100p"
                  style="border-radius: 0 0 10px 10px"
                  v-if="mode != 4 && $route.params.bid > 0"
                >
                  <div class="btn-group">
                    <button
                      @click="prevOrNextContent(-1)"
                      class="btn btn-xs btn-light d-flex align-items-center"
                    >
                      <img
                        :src="
                          `${myResBaseUrl}v4-assets/svgicon/arrows/outline/direction-left 01.svg`
                        "
                        class="mg-r-5 ht-16-f wd-16-f"
                      />
                      <span class="d-none d-sm-block">Өмнөх контент</span>
                    </button>
                    <button
                      @click="prevOrNextContent(1)"
                      class="btn btn-xs btn-light d-flex align-items-center"
                    >
                      <span class="d-none d-sm-block">Дараах контент</span>
                      <img
                        :src="
                          `${myResBaseUrl}v4-assets/svgicon/arrows/outline/direction-right 01.svg`
                        "
                        class="mg-l-5 ht-16-f wd-16-f"
                      />
                    </button>
                  </div>
                  <div v-if="fileInf.ready">
                    <div
                      class="dropdown dropup"
                      v-if="$store.state.app.isMobile"
                    >
                      <button
                        class="btn btn-xs btn-outline-primary d-flex align-items-center dropdown-toggle mg-l-5"
                        type="button"
                        id="dropdownDwnldButton"
                        data-toggle="dropdown"
                        aria-haspopup="true"
                        aria-expanded="false"
                      >
                        <feather type="download" size="16"></feather>
                      </button>
                      <div
                        class="dropdown-menu"
                        aria-labelledby="dropdownDwnldButton"
                      >
                        <a
                          v-if="fileInf.obj.isPublic"
                          class="dropdown-item"
                          @click="downloadAttachment()"
                          >Татаж авах</a
                        >
                        <a class="dropdown-item" @click="downloadOffline()"
                          >Офллайн үзэх</a
                        >
                      </div>
                    </div>
                    <button
                      v-else-if="fileInf.obj.isPublic"
                      @click="downloadAttachment()"
                      type="button"
                      class="btn btn-xs btn-icon"
                    >
                      <img
                        :src="
                          `${myResBaseUrl}v4-assets/svgicon/files and folder/outline/archive-download.svg`
                        "
                        class="mg-r-5"
                      />
                      <span>Татах</span>
                    </button>
                  </div>
                  <div class="d-flex align-items-center">
                    <button
                      v-if="$route.params.iid > 0 && showTaskOrAttachDone"
                      @click="markAsCompleteItem()"
                      type="button"
                      :class="
                        `btn btn-xs btn-icon btn-light d-flex align-items-center`
                      "
                    >
                      <img
                        :src="
                          `${myResBaseUrl}v4-assets/svgicon/notes and task/outline/task-check.svg`
                        "
                        class="mg-r-5"
                      />
                      <span class="d-none d-sm-block pd-r-5">Контентийг</span> үзсэн?
                    </button>
                    <button
                      v-if="
                        !lesson.isDone &&
                          lesson.isRepeat != undefined &&
                          lesson.isRepeat == false
                      "
                      @click="lessonFinish()"
                      type="button"
                      :class="
                        `btn btn-xs btn-icon btn-light mg-l-5 d-flex align-items-center`
                      "
                      title="Хичээлийг дуусгах ?"
                    >
                      <img
                        :src="
                          `${myResBaseUrl}v4-assets/svgicon/interface/outline/check-rectangle.svg`
                        "
                        class="mg-r-5"
                      />
                      <span class="d-none d-sm-block pd-r-5">Хичээлийг</span> дуусгах?
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div
            class="pos-fixed r-30 b-80"
            style="z-index: 11"
            v-if="courseInf.i5 != undefined && courseInf.i5 == 1"
            @click="openChatBar()"
          >
            <button type="button" class="btn btn-primary btn-icon pos-relative">
              <feather type="message-circle"></feather> Чат
              <sup v-if="chatCount.allCount">{{ chatCount.allCount }}</sup>
              <div
                class="badge badge-danger mg-l-auto r--10 t--10"
                v-show="chatCount.notSeenCount"
                style="position: absolute !important; "
              >
                {{ chatCount.notSeenCount }}
              </div>
            </button>
          </div>
        </div>
      </div>
    </div>

    <div class="d-none">
      <lesson-header
        v-if="$store.state.app.mainLayoutConfig.header != null && lessonRdy"
        @toggle-navbar="toggleNavbar($event)"
        :navbarmode.sync="navbarMode"
        :rightSideBar.sync="rightSideBar"
        :lesson.sync="lesson"
        @on-back-to-course="backToCourse()"
        @toggle-team-chat="toggleTeamChat"
        @toggle-filling-sidebar="toggleFillingSidebar"
      />

      <div class="course-sidebar">
        <div class="course-sidebar-header">
          <div
            class="d-flex align-items-center justify-content-between wd-100p"
          >
            <div
              class="wd-50p d-flex course-name"
              role="button"
              @click="backToCourse()"
            >
              <feather type="chevron-left" class="tx-color-02"></feather>
              <div class="text-muted text-uppercase tx-11 pd-t-5">Буцах</div>
            </div>
          </div>
        </div>
        <div class="course-sidebar-body"></div>
      </div>
      <div class="course-content no-header">
        <div class="course-content-body">
          <div class="d-flex mx-wd-100p-f">
            <div
              :class="
                `main-area wd-${showRightSide ? '75' : '100'}p pos-relative`
              "
            >
              <template v-if="courseReady">
                <course-navbar
                  v-if="$store.state.app.mainLayoutConfig.header != 22"
                  @on-toggle-nav="expanded = !expanded"
                  @on-toggle-content="toggleContent"
                  @on-toggle-right-side="showRightSide = !showRightSide"
                  :showRightSide.sync="showRightSide"
                  :course="course"
                ></course-navbar>
              </template>
              <vue-custom-scrollbar
                class="lesson-custom-scroll"
                :style="`height: ${scrollHeight}px !important`"
              >
                <div
                  :class="
                    `${
                      $store.state.app.isMobile || cntntNoPdn
                        ? 'pd-0-f'
                        : 'pd-15'
                    }`
                  "
                ></div>
              </vue-custom-scrollbar>
              <div
                v-if="mode != 4 && !$store.state.app.mainLayoutConfig.expanded"
                style="position: absolute; width: 100%"
                :class="
                  `bd-t bg-${
                    $store.state.app.skin.dark ? 'dark' : 'white'
                  } ht-55 pd-x-${
                    $store.state.app.isMobile ? '5' : '20'
                  } d-flex flex-row align-items-center justify-content-between`
                "
              >
                <template v-if="!hideFooter">
                  <div class="d-flex align-items-center">
                    <div v-if="fileInf.ready">
                      <div
                        class="dropdown dropup"
                        v-if="$store.state.app.isMobile"
                      >
                        <button
                          class="btn btn-xs btn-outline-primary d-flex align-items-center dropdown-toggle mg-l-5"
                          type="button"
                          id="dropdownDwnldButton"
                          data-toggle="dropdown"
                          aria-haspopup="true"
                          aria-expanded="false"
                        >
                          <feather type="download" size="16"></feather>
                        </button>
                        <div
                          class="dropdown-menu"
                          aria-labelledby="dropdownDwnldButton"
                        >
                          <a
                            v-if="fileInf.obj.isPublic"
                            class="dropdown-item"
                            @click="downloadAttachment()"
                            >Татаж авах</a
                          >
                          <a class="dropdown-item" @click="downloadOffline()"
                            >Офллайн үзэх</a
                          >
                        </div>
                      </div>
                      <button
                        v-else-if="fileInf.obj.isPublic"
                        @click="downloadAttachment()"
                        type="button"
                        class="btn btn-xs btn-outline-primary d-flex align-items-center"
                      >
                        <feather
                          type="download"
                          size="16"
                          class="mg-r-5"
                        ></feather>
                        <span>Татах</span>
                      </button>
                    </div>
                    <attach-rating
                      v-if="fileInf.ready"
                      :fileInf.sync="fileInf"
                      class="mg-l-10"
                      @on-rate="onRated"
                      :allowHalf="false"
                    />
                  </div>
                  <nav class="nav mg-l-auto" v-if="!$store.state.app.isMobile">
                    <button
                      @click="lessonNextprev(-1)"
                      type="button"
                      :class="
                        `btn btn-xs btn-outline-${
                          $store.state.app.skin.dark ? 'white' : 'dark'
                        } btn-icon mg-r-5`
                      "
                      title="Өмнөх хичээл"
                    >
                      <feather
                        type="chevrons-left"
                        size="16"
                        title="Өмнөх хичээл"
                      ></feather>
                    </button>
                    <button
                      v-if="$route.params.bid > 0"
                      @click="prevOrNextContent(-1)"
                      type="button"
                      :class="
                        `btn btn-xs btn-outline-${
                          $store.state.app.skin.dark ? 'white' : 'secondary'
                        } btn-icon`
                      "
                      title="Өмнөх контент"
                    >
                      <feather
                        type="arrow-left"
                        size="16"
                        title="Өмнөх контент"
                      ></feather>
                    </button>
                    <button
                      @click="markAsCompleteItem()"
                      v-if="$route.params.iid > 0 && showTaskOrAttachDone"
                      type="button"
                      :class="
                        `btn btn-xs ${
                          $store.state.app.skin.dark
                            ? 'btn-outline-white'
                            : 'btn-brand-02'
                        } btn-icon mg-l-5`
                      "
                    >
                      <feather type="check" size="16" class="mg-r-5"></feather
                      >Контентийг үзэж дуусгах
                    </button>
                    <button
                      v-if="$route.params.bid > 0"
                      @click="prevOrNextContent(1)"
                      type="button"
                      :class="
                        `btn btn-xs btn-outline-${
                          $store.state.app.skin.dark ? 'white' : 'secondary'
                        } btn-icon mg-l-5`
                      "
                      title="Дараах контент"
                    >
                      <feather
                        type="arrow-right"
                        size="16"
                        title="Дараах контент"
                      ></feather>
                    </button>
                    <button
                      v-if="$route.params.bid == 0"
                      @click="prevOrNextContent(0)"
                      type="button"
                      :class="
                        `btn btn-xs btn-outline-${
                          $store.state.app.skin.dark ? 'white' : 'dark'
                        } d-flex flex-row align-items-center`
                      "
                    >
                      <span class="tx-13 text-uppercase">Хичээл үзэх</span>
                      <feather type="play" :size="16" class="mg-l-5"></feather>
                    </button>
                    <button
                      @click="lessonNextprev(1)"
                      type="button"
                      :class="
                        `btn btn-xs btn-outline-${
                          $store.state.app.skin.dark ? 'white' : 'dark'
                        } btn-icon mg-l-5`
                      "
                      title="Дараагийн хичээл"
                    >
                      <feather
                        type="chevrons-right"
                        size="16"
                        title="Дараагийн хичээл"
                      ></feather>
                    </button>

                    <button
                      @click="lessonFinish()"
                      v-if="
                        !lesson.isDone &&
                          lesson.isRepeat != undefined &&
                          lesson.isRepeat == false
                      "
                      type="button"
                      :class="
                        `btn btn-xs ${
                          $store.state.app.skin.dark
                            ? 'btn-outline-white'
                            : 'btn-brand-02'
                        } btn-icon btn-uppercase mg-l-5`
                      "
                      title="Хичээлийг дуусгах ?"
                    >
                      <feather
                        type="check-square"
                        size="16"
                        title="Хичээлийг дуусгах ?"
                      ></feather>
                      Хичээлийг дуусгах ?
                    </button>
                  </nav>
                  <nav class="nav mg-l-auto" v-else>
                    <button
                      v-if="$route.params.bid > 0"
                      @click="prevOrNextContent(-1)"
                      type="button"
                      :class="
                        `btn btn-xs btn-outline-${
                          $store.state.app.skin.dark ? 'white' : 'secondary'
                        } btn-icon`
                      "
                      title="Өмнөх контент"
                    >
                      <feather
                        type="arrow-left"
                        size="16"
                        title="Өмнөх контент"
                      ></feather>
                    </button>
                    <button
                      @click="markAsCompleteItem()"
                      v-if="$route.params.iid > 0 && showTaskOrAttachDone"
                      type="button"
                      :class="
                        `btn btn-xs btn-outline-${
                          $store.state.app.skin.dark ? 'white' : 'dark'
                        } btn-icon mg-l-5`
                      "
                      title="Контентийг үзэж дуусгах"
                    >
                      <feather
                        type="check"
                        size="16"
                        class=""
                        title="Контентийг үзэж дуусгах"
                      ></feather>
                    </button>
                    <button
                      v-if="$route.params.bid > 0"
                      @click="prevOrNextContent(1)"
                      type="button"
                      :class="
                        `btn btn-xs btn-outline-${
                          $store.state.app.skin.dark ? 'white' : 'secondary'
                        } btn-icon mg-l-5`
                      "
                      title="Дараах контент"
                    >
                      <feather
                        type="arrow-right"
                        size="16"
                        title="Дараах контент"
                      ></feather>
                    </button>
                    <div class="dropdown dropup">
                      <button
                        :class="
                          `btn btn-outline-${
                            $store.state.app.skin.dark ? 'white' : 'dark'
                          } mg-l-5`
                        "
                        id="dropdownMenuButton"
                        data-toggle="dropdown"
                      >
                        <feather type="menu" size="16"></feather>
                      </button>
                      <div
                        class="dropdown-menu"
                        aria-labelledby="dropdownMenuButton"
                      >
                        <a class="dropdown-item" @click="lessonNextprev(-1)"
                          >Өмнөх хичээл</a
                        >
                        <a class="dropdown-item" @click="lessonNextprev(1)"
                          >Дараах хичээл</a
                        >
                        <a
                          class="dropdown-item"
                          @click="lessonFinish()"
                          v-if="
                            !lesson.isDone &&
                              lesson.isRepeat != undefined &&
                              lesson.isRepeat == false
                          "
                          >Хичээлийг дуусгах ?</a
                        >
                      </div>
                    </div>
                  </nav>
                </template>
              </div>
            </div>
            <div
              v-if="showRightSide"
              :class="
                `team-chat wd-25p bd-l bg-${
                  $store.state.app.skin.dark ? 'dark' : 'white'
                } ht-100v`
              "
            >
              <ul
                class="nav nav-line"
                id="myTab5"
                role="tablist"
                style="height: 56px"
              >
                <li class="nav-item pd-l-20 wd-40p" v-if="showChatBox">
                  <a
                    role="button"
                    style="height: 52px"
                    @click="rightSideActiveTab = 1"
                    class="nav-link d-flex justify-content-center align-items-center"
                    :class="{ active: rightSideActiveTab == 1 }"
                  >
                    <feather
                      type="message-square"
                      :stroke-width="1"
                      class="mg-r-5 mg-l-5 wd-20-f ht-20-f"
                    ></feather
                    >Чат
                  </a>
                </li>
                <li class="nav-item wd-40p">
                  <a
                    role="button"
                    style="height: 52px"
                    @click="rightSideActiveTab = 2"
                    class="nav-link d-flex justify-content-center align-items-center"
                    :class="{ active: !showChatBox || rightSideActiveTab == 2 }"
                  >
                    <feather
                      type="clipboard"
                      :stroke-width="1"
                      class="mg-r-5 mg-l-5 wd-20-f ht-20-f"
                    ></feather
                    >Тэмдэглэл
                  </a>
                </li>
              </ul>
              <team-preview
                v-if="
                  rightSideActiveTab == 1 && lesson.teamId > 0 && showChatBox
                "
                :teamId="lesson.teamId"
                :obj="{ title: sendObjTitle() }"
                @on-attach="onAttach"
              />
              <task-notes
                v-if="lesson.id > 0"
                :taskId="lesson.id"
                @on-attach="onAttach"
                :obj="{ title: sendObjTitle(), name: lesson.name }"
              />
            </div>
          </div>
        </div>
      </div>
    </div>

    <b-sidebar
      v-model="sideBar.teamChat"
      title="Чат"
      shadow
      right
      width="400px"
    >
      <div class="px-3 py-2 bg-white" v-if="sideBar.teamChat">
        <team-preview
          :teamId.sync="lesson.teamId"
          :obj="{ title: sendObjTitle() }"
          @on-attach="onAttach"
        />
      </div>
    </b-sidebar>

    <b-modal
      v-model="lessonFinishConfirm"
      hide-footer
      centered
      title="Хичээлийг дуусгах"
    >
      <div class="mg-x-20">
        <div class="text-center pd-20">
          <feather
            type="smile"
            :size="64"
            class="mg-b-20 text-success"
          ></feather>
          <h5
            class="text-truncate tx-14-f"
            style="white-space: normal; max-height: 40px; min-height: 40px"
          >
            Та хичээлийн бүх агуулгыг үзэж дуусгалаа. Хичээлийг дуусгах уу ?
          </h5>
        </div>
        <div class="text-center">
          <div class="btn-group">
            <button
              @click="lessonFinishConfirm = false"
              class="btn btn-sm pd-x-15 btn-secondary btn-uppercase"
            >
              Үгүй
            </button>
            <button
              @click="lessonFinish()"
              class="btn btn-sm pd-x-15 btn-success btn-uppercase"
            >
              Тийм
            </button>
          </div>
        </div>
      </div>
    </b-modal>

    <b-modal
      v-model="courseFinishConfirm.modal"
      hide-footer
      centered
      :no-close-on-backdrop="courseFinishConfirm.hasRatingSurvey"
      title="Баярлалаа"
      :hide-header-close="true"
    >
      <div class="mg-x-20">
        <div class="text-center pd-20">
          <h5
            class="text-truncate tx-14-f"
            style="white-space: normal; max-height: 40px; min-height: 40px"
            v-if="courseFinishConfirm.hasRatingSurvey"
          >
            Та сургалтын бүх хичээлийг үзэж дуусгалаа. Сургалтад үнэлгээ өгнө
            үү?
          </h5>
          <div v-else>
            <img src="assets/svg/done.svg" />
            <h5
              class="text-truncate tx-14-f"
              style="white-space: normal; max-height: 40px; min-height: 40px"
            >
              Та сургалтын бүх хичээлийг үзэж дуусгалаа. Танд баярлалаа
            </h5>
          </div>
        </div>
        <div v-if="rateRdy" class="text-center mg-b-20">
          <task-rating
            :taskId.sync="$route.params.cid"
            @on-rated="
              rateRdy = false;
              open503();
            "
            :allowHalf="true"
          />
        </div>
        <div class="text-center">
          <div
            class="btn-group"
            v-if="courseFinishConfirm.hasRatingSurvey"
          ></div>
          <div v-else>
            <button
              @click="courseFinishConfirm.modal = false"
              class="btn btn-sm pd-x-15 btn-secondary btn-uppercase"
            >
              Хаах
            </button>
          </div>
        </div>
      </div>
    </b-modal>

    <file-sidebar
      :id.sync="fileSidebar.id"
      :show="fileSidebar.show"
      @on-hide="fileSidebarClosed"
    />

    <re-buy-lesson
      :reBuyModal="reBuyModal"
      :itemId="parseInt($route.params.cid, 10)"
      :course="course"
      :reBuyObj="reBuyObj"
      @on-hide="reBuyModal = false"
    />
    <b-modal
      title="Тайлбар"
      v-model="htmlObj.modal"
      hide-footer
      @hide="onHideHtmlObj"
      centered
    >
      <div v-html="htmlObj.html"></div>
    </b-modal>

    <b-modal
      :title="formFillOnModal.title"
      v-model="formFillOnModal.mdl"
      content-class="rounded-20 pd-20"
      centered
      size="lg"
      scrollable
      :hide-header-close="hdrCloseHide"
      :no-close-on-backdrop="true"
    >
      <form-fill
        ref="frmFillMdl"
        :id="formFillOnModal.id"
        :boxId="formFillOnModal.boxId"
        :boxOt="formFillOnModal.boxOt"
        :prms="formFillOnModal.prms"
        :hideFooter="true"
        :fromModal="true"
        @activate-modal-close="hdrCloseHide = false"
      ></form-fill>
      <template #modal-footer>
        <div class="text-center">
          <button
            v-show="hdrCloseHide"
            @click="mddlClose()"
            class="btn btn-primary wd-200"
          >
            <feather type="check"></feather>
            {{ formFillOnModal.boxOt == 503 ? "Үнэлэх" : "Дуусгах" }}
          </button>
        </div>
      </template>
    </b-modal>
  </div>
</template>

<script>
import AsyncLoadError from "@/components/base/asyncLoadingError";
import AsyncLoading from "@/components/base/asyncLoading";
import vueCustomScrollbar from "vue-custom-scrollbar";

import { request } from "@/api/all";
import { getIdFromUrl } from "vue-youtube";

import "element-ui/lib/theme-chalk/index.css";
import { Notification, Message, MessageBox } from "element-ui";
import { mapActions } from "vuex";

import { getFileMode } from "@/libs/tools";

import Axios from "axios";
//import { saveAs } from 'file-saver';

import config from "@/config";
const { resBaseUrl } = config;

export default {
  components: {
    vueCustomScrollbar,
    courseOverview: () => ({
      component: import("@/views/modules/lms/student/sections/aboutCourse.vue"),
      loading: AsyncLoading,
      error: AsyncLoadError,
      delay: 100,
      timeout: 5000,
    }),
    studentHeader: () => ({
      component: import("@/views/modules/lms/student/components/header.vue"),
      loading: AsyncLoading,
      error: AsyncLoadError,
      delay: 100,
      timeout: 5000,
    }),
    courseNavbar: () => ({
      component: import(
        "@/views/modules/lms/student/components/courseAndLessonDetailNav.vue"
      ),
      loading: AsyncLoading,
      error: AsyncLoadError,
      delay: 100,
      timeout: 5000,
    }),
    lessonHeader: () => ({
      component: import(
        "@/views/modules/lms/student/components/headerLesson.vue"
      ),
      loading: AsyncLoading,
      error: AsyncLoadError,
      delay: 100,
      timeout: 5000,
    }),

    fillSidebar: () => ({
      component: import("@/components/modules/form/fill/component/sidebar.vue"),
      loading: AsyncLoading,
      error: AsyncLoadError,
      delay: 100,
      timeout: 5000,
    }),
    reBuyLesson: () => ({
      component: import("@/views/modules/lms/student/components/rebuy.vue"),
      loading: AsyncLoading,
      error: AsyncLoadError,
      delay: 100,
      timeout: 5000,
    }),
    navDynamic: () => ({
      component: import(
        "@/views/modules/lms/student/components/navDynamic.vue"
      ),
      loading: AsyncLoading,
      error: AsyncLoadError,
      delay: 100,
      timeout: 5000,
    }),
    filePreview: () => ({
      component: import("@/components/modules/media/previewPage.vue"),
      loading: AsyncLoading,
      error: AsyncLoadError,
      delay: 100,
      timeout: 5000,
    }),
    youtubePreview: () => ({
      component: import("@/components/modules/media/components/youtube"),
      loading: AsyncLoading,
      error: AsyncLoadError,
      delay: 100,
      timeout: 5000,
    }),
    teamPreview: () => ({
      component: import("@/components/modules/team/embed.vue"),
      loading: AsyncLoading,
      error: AsyncLoadError,
      delay: 100,
      timeout: 5000,
    }),
    taskNotes: () => ({
      component: import("@/components/task/components/notes"),
      loading: AsyncLoading,
      error: AsyncLoadError,
      delay: 100,
      timeout: 5000,
    }),
    formFill: () => ({
      component: import("@/components/modules/form/fill"),
      loading: AsyncLoading,
      error: AsyncLoadError,
      delay: 100,
      timeout: 5000,
    }),
    attachmentList: () => ({
      component: import(
        "@/views/modules/lms/student/sections/attachmentList.vue"
      ),
      loading: AsyncLoading,
      error: AsyncLoadError,
      delay: 100,
      timeout: 5000,
    }),
    youtubeList: () => ({
      component: import("@/views/modules/lms/student/sections/youtubeList.vue"),
      loading: AsyncLoading,
      error: AsyncLoadError,
      delay: 100,
      timeout: 5000,
    }),
    lessonOverview: () => ({
      component: import("@/views/modules/lms/student/sections/aboutLesson.vue"),
      loading: AsyncLoading,
      error: AsyncLoadError,
      delay: 100,
      timeout: 5000,
    }),
    faqDetail: () => ({
      component: import("@/views/modules/lms/student/sections/faqDetail.vue"),
      loading: AsyncLoading,
      error: AsyncLoadError,
      delay: 100,
      timeout: 5000,
    }),
    faqList: () => ({
      component: import("@/views/modules/lms/student/sections/faqList.vue"),
      loading: AsyncLoading,
      error: AsyncLoadError,
      delay: 100,
      timeout: 5000,
    }),
    embedList: () => ({
      component: import("@/views/modules/lms/student/sections/embedList.vue"),
      loading: AsyncLoading,
      error: AsyncLoadError,
      delay: 100,
      timeout: 5000,
    }),
    embedDetail: () => ({
      component: import("@/views/modules/lms/student/sections/embedDetail.vue"),
      loading: AsyncLoading,
      error: AsyncLoadError,
      delay: 100,
      timeout: 5000,
    }),
    htmlList: () => ({
      component: import("@/views/modules/lms/student/sections/htmlList.vue"),
      loading: AsyncLoading,
      error: AsyncLoadError,
      delay: 100,
      timeout: 5000,
    }),
    htmlDetail: () => ({
      component: import("@/views/modules/lms/student/sections/htmlDetail.vue"),
      loading: AsyncLoading,
      error: AsyncLoadError,
      delay: 100,
      timeout: 5000,
    }),
    linkList: () => ({
      component: import("@/views/modules/lms/student/sections/linkList.vue"),
      loading: AsyncLoading,
      error: AsyncLoadError,
      delay: 100,
      timeout: 5000,
    }),
    fileSidebar: () => ({
      component: import("@/components/modules/media/preview.vue"),
      loading: AsyncLoading,
      error: AsyncLoadError,
      delay: 100,
      timeout: 5000,
    }),
    formList: () => ({
      component: import("@/views/modules/lms/student/sections/formList.vue"),
      loading: AsyncLoading,
      error: AsyncLoadError,
      delay: 100,
      timeout: 5000,
    }),
    attachRating: () => ({
      component: import("@/components/modules/media/rate.vue"),
      loading: AsyncLoading,
      error: AsyncLoadError,
      delay: 100,
      timeout: 5000,
    }),
    taskRating: () => ({
      component: import("@/components/task/components/actions/rate.vue"),
      loading: AsyncLoading,
      error: AsyncLoadError,
      delay: 100,
      timeout: 5000,
    }),
  },

  data() {
    return {
      chatCount: {
        allCount: 0,
        notSeenCount: 0,
      },
      hdrCloseHide: true,
      formFillOnModal: {
        id: null,
        title: null,
        boxId: null,
        boxOt: null,
        prms: null,
        mdl: false,
      },
      fillSidebarData: {
        rdy: false,
        mode: null,
        prms: null,
        form: null,
      },
      course: {},
      courseReady: false,
      lessonRdy: false,
      fileInf: {
        ready: false,
        obj: {},
      },
      cntntNoPdn: false,
      showRightSide: false,
      rightSideActiveTab: 1,
      showChatBox: false,
      lesson: {
        boxes: [],
      },
      lessonMenu: [],
      mode: 0,

      navbarMode: 0,
      rightSideBar: false,
      sideBar: {
        teamChat: false,
      },

      filePreview: {
        show: false,
        id: 0,
      },
      boxObj: {
        attachments: [],
        tasks: [],
        attachmentsCount: 0,
        box: {},
      },
      boxRdy: false,
      boxOt: null,
      taskObj: {
        task: {},
        rdy: false,
      },
      showTaskOrAttachDone: true,
      lessonFinishConfirm: false,
      fileSidebar: {
        show: false,
        id: 0,
        fromInteractive: false,
      },
      fillingFormKey: 0,
      hideFooter: false,
      expanded: true,
      courseFinishConfirm: {
        modal: false,
        ratingSurveyLink: "",
        hasRatingSurvey: false,
      },
      rateRdy: true,
      reBuyModal: false,
      reBuyObj: {},
      courseInf: {},
      fileSystem: null,
      fsType: window.PERSISTENT,
      fsSize: 10000 * 1024 * 1024,

      htmlObj: {
        html: "",
        modal: false,
      },
      scrollHeight: 0,

      myResBaseUrl: resBaseUrl,
    };
  },
  mounted() {
    window.addEventListener("resize", this.getScrollHeight);
    this.init();
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.getScrollHeight);
  },
  destroyed() {},
  methods: {
    goToQ(e) {
      this.$refs.frmFill.goToQ(e);
    },
    openChatBar() {
      this.chatCount.notSeenCount = 0;
      this.sideBar.teamChat = true;
    },
    showExamResult(e) {
      this.toggleBodyClass("addClass", "dynamic-locker");
      request({
        api: { method: "GET", url: "learn/GetExamResult" },
        params: { courseId: this.$route.params.cid, examId: e },
        store: this.$store,
      }).then((res) => {
        this.toggleBodyClass("removeClass", "dynamic-locker");
        if (res != false) {
          let _txt = "";
          if (res.data.examCode == 1) {
            _txt =
              res.data.msg +
              " " +
              ((res.data.truePoint * 100) / res.data.questionPoint).toFixed(2) +
              "%";
          } else if (res.data.examCode == 2) {
            _txt = "Шалгалтын огноо эхлээгүй/дуусаагүй байна";
          } else if (res.data.examCode == 3 || res.data.examCode == 6) {
            _txt = "Шалгалтын үр дүнг харах боломжгүй";
          } else if (res.data.examCode == 4) {
            _txt = "Шалгалтын үр дүнг илгээгээгүй";
          } else {
            _txt = "Шалгалтын өгөгдөл илгээсэн байна";
          }

          MessageBox({
            title: "Дүн харах",
            message: _txt,
            showConfirmButton: false,
          });
        }
      });
    },
    mddlClose() {
      this.toggleBodyClass("addClass", "dynamic-locker");
      request({
        api: { method: "POST", url: "Form/SurveyRefillByCourseIdLessonId" },
        data: {
          courseId: this.$route.params.cid,
          id: this.formFillOnModal.id,
        },
        store: this.$store,
      }).then((res) => {
        this.toggleBodyClass("removeClass", "dynamic-locker");
        if (res != false) {
          Message("Баярлалаа");
          this.formFillOnModal.mdl = false;
        }
      });
    },
    ...mapActions([
      "handleMainLayoutConfig",
      "handleOfflineAttaches",
      "handleTeamNotSeenCount",
    ]),
    onModalFormFill(e) {
      if (e.prms.questionShuffle != undefined && e.prms.questionShuffle > 0) {
        e.prms.questionShuffle = true;
      } else {
        e.prms.questionShuffle = false;
      }
      this.formFillOnModal.id = e.id;
      this.formFillOnModal.title = e.prms.nm;
      this.formFillOnModal.boxId = e.bid;
      this.formFillOnModal.boxOt = e.bot;
      this.formFillOnModal.prms = e.prms;
      this.$nextTick(() => {
        this.formFillOnModal.mdl = true;
      });
    },
    readFile(path, success) {
      let self = this;
      this.fileSystem.root.getFile(
        path,
        {},
        function(fileEntry) {
          fileEntry.file(function(file) {
            var reader = new FileReader();
            reader.onloadend = function(e) {
              if (success) {
                self.readAfter(this.result);
              }
            };
            reader.readAsArrayBuffer(file);
          }, self.errorHandler);
        },
        self.errorHandler
      );
    },
    readAfter(e) {
      var fileURL = window.URL.createObjectURL(new Blob([e]));
      var video2 = document.getElementById("video2");
      video2.src = fileURL;
    },
    test2() {
      window.showSaveFilePicker();
    },
    viewOffline() {
      this.readFile("582159.jpg", true);
    },
    downloadOffline() {
      let self = this;
      window.requestFileSystem =
        window.requestFileSystem || window.webkitRequestFileSystem;
      window.storageInfo = window.storageInfo || window.webkitStorageInfo;

      window.storageInfo.requestQuota(
        self.fsType,
        self.fsSize,
        function(gb) {
          window.requestFileSystem(
            self.fsType,
            gb,
            function(fs) {
              self.fileSystem = fs;
            },
            self.errorHandler
          );
        },
        self.errorHandler
      );
      if (getFileMode(this.fileInf.obj.ext) != "document") {
        this.toggleBodyClass("addClass", "dynamic-locker");
        Axios({
          url: self.fileInf.obj.link,
          method: "GET",
          responseType: "blob",
        }).then((res) => {
          this.toggleBodyClass("removeClass", "dynamic-locker");
          self.downloadOfflineSave(
            res.data,
            self.fileInf.obj.id + "." + self.fileInf.obj.ext
          );
        });
      } else {
        Notification({
          title: "Документ төрлийн файлыг татах боломжгүй",
          type: "warning",
        });
      }
    },

    downloadOfflineSave(data, path) {
      let self = this;
      if (!self.fileSystem) return;
      this.toggleBodyClass("addClass", "dynamic-locker");
      self.fileSystem.root.getFile(
        path,
        { create: true },
        function(fileEntry) {
          fileEntry.createWriter(function(writer) {
            writer.write(data);
            self.downloadOfflineJson();
          }, self.errorHandler);
        },
        self.errorHandler
      );
    },
    downloadOfflineJson() {
      const items = localStorage.getItem("off_courses");
      if (items) {
        const itemsData = JSON.parse(items);
        if (
          itemsData.filter((item) => item.id === this.course.id).length == 0
        ) {
          itemsData.push(this.course);
          localStorage.setItem("off_courses", JSON.stringify(itemsData));
        }
      } else {
        localStorage.setItem("off_courses", JSON.stringify([this.course]));
      }

      const items_lessons = localStorage.getItem("off_lessons");
      let _real_lsn = Object.assign({}, this.lesson, {
        courseId: this.course.id,
      });
      if (items_lessons) {
        const itemsData_lsn = JSON.parse(items_lessons);
        if (!itemsData_lsn.find((item) => item.id === _real_lsn.id)) {
          itemsData_lsn.push(_real_lsn);
          localStorage.setItem("off_lessons", JSON.stringify(itemsData_lsn));
        }
      } else {
        localStorage.setItem("off_lessons", JSON.stringify([_real_lsn]));
      }

      const items_files = localStorage.getItem("off_files");
      let _real_file = Object.assign({}, this.fileInf.obj, {
        lessonId: this.lesson.id,
        courseId: this.course.id,
      });
      if (items_files) {
        const itemsData_fls = JSON.parse(items_files);
        if (!itemsData_fls.find((item) => item.id === _real_file.id)) {
          itemsData_fls.push(_real_file);
          localStorage.setItem("off_files", JSON.stringify(itemsData_fls));
        }
      } else {
        localStorage.setItem("off_files", JSON.stringify([_real_file]));
      }
      this.toggleBodyClass("removeClass", "dynamic-locker");

      Notification.info({
        message: "Файлыг амжилттай татлаа.",
        duration: 5000,
        type: "success",
        position: "top-right",
        offset: 50,
      });
      this.handleOfflineAttaches();
    },
    errorHandler(e) {
      this.toggleBodyClass("removeClass", "dynamic-locker");
      var msg = "";
    },
    toggleNav() {
      this.expanded = !this.expanded;
    },
    getIdFromUrl(url) {
      return getIdFromUrl(url);
    },
    toggleBodyClass(addRemoveClass, className) {
      const el = document.body;

      if (addRemoveClass === "addClass") {
        el.classList.add(className);
      } else {
        el.classList.remove(className);
      }
    },
    shwCrseLessons() {
      this.$refs.dnmchdr.showLevel2();
    },
    toggleNavbar(shown) {
      if (this.navbarMode == 0) {
        this.navbarMode = 1;
        this.toggleBodyClass("addClass", "course-sidebar-show");
      } else if (this.navbarMode == 1) {
        if (shown) {
          this.toggleBodyClass("addClass", "navbar-nav-show");
        } else {
          this.navbarMode = 0;
          this.toggleBodyClass("removeClass", "course-sidebar-show");
        }
      }
    },
    toggleFillingSidebar() {
      this.rightSideBar = !this.rightSideBar;
    },
    toggleTeamChat() {
      this.sideBar.teamChat = true;
    },
    getBreadcrumbTitle() {
      let rv = "";
      let _b = this.lesson.boxes.filter((b) => b.id == this.$route.params.bid);
      if (_b.length) {
        if (_b[0].tasks.length) {
          let _i = _b[0].tasks.filter((x) => x.id == this.$route.params.iid);
          if (_i.length) rv = _i[0].task;
        } else if (_b[0].forms.length) {
          let _i = _b[0].forms.filter((x) => x.id == this.$route.params.iid);
          if (_i.length) rv = _i[0].nm;
        } else if (_b[0].attaches.length) {
          let _i = _b[0].attaches.filter((x) => x.id == this.$route.params.iid);
          if (_i.length) rv = _i[0].t != "" ? _i[0].t : _i[0].n;
        }
      }
      return rv;
    },
    init(tmpShowRight) {
      if (this.$route.params.id > 0) {
        this.initCourseInfo(tmpShowRight);
      } else {
        Notification.info({
          message: "Сургалт дотор хичээлгүй байна.",
          duration: 5000,
          type: "info",
          position: "top-right",
          offset: 50,
        });

        this.$router.push({
          name: "lmsCourseView",
          params: { id: this.$route.params.cid },
        });
      }
    },
    initCourseInfo(tmpShowRight) {
      request({
        api: { method: "get", url: "v2/learn/courseinfo" },
        params: { id: this.$route.params.cid },
        store: this.$store,
      }).then((res) => {
        if (res != false) {
          // console.log('res', res);
          this.course = res.data.course;
          this.courseInf = res.data.course;
          this.courseReady = true;
          this.initLesson(tmpShowRight);
        }
      });
    },
    fetchCourseChatCount(_teamId) {
      this.$store.state.signalr.osrCon.on(
        "v2recieveTeamMessage",
        (
          date,
          teamId,
          msg,
          type,
          objectId,
          profileId,
          fullName,
          avator,
          attach,
          cstmResp
        ) => {
          if (_teamId == teamId) {
            this.chatCount.notSeenCount++;
          }
        }
      );
      this.toggleBodyClass("addClass", "dynamic-locker");
      request({
        api: { method: "GET", url: "team/GetTeamHistoryCount" },
        params: { teamId: _teamId },
        store: this.$store,
      }).then((res) => {
        this.toggleBodyClass("removeClass", "dynamic-locker");
        if (res != false) {
          this.chatCount.allCount = res.data.allCount;
          this.chatCount.notSeenCount = res.data.notSeenCount;
        }
      });
    },
    initLesson(tmpShowRight) {
      this.toggleBodyClass("addClass", "dynamic-locker");
      request({
        api: { method: "GET", url: "learn/lessonDetail" },
        params: {
          id: this.$route.params.id,
          cid: this.$route.params.cid,
          isMobile: this.$store.state.app.isMobile,
        },
        store: this.$store,
      }).then((res) => {
        this.toggleBodyClass("removeClass", "dynamic-locker");
        if (res != false) {
          if(res.result==1){
            res.data.lesson.boxes.map((b) => {
              if (b.ot == 122 || b.ot == 286) b.icon = "video";
              else if (b.ot == 117 || b.ot == 416 || b.ot == 389)
                b.icon = "pen-tool";
              else if (b.ot == 6 || b.ot == 435) b.icon = "file";
              else if (b.ot == 422) b.icon = "link";
            });
            this.lessonMenu = res.data.courseInLessonList;
            this.lesson = res.data.lesson;
            if (this.courseInf.i5 != undefined && this.courseInf.i5 > 0) {
              this.fetchCourseChatCount(this.lesson.teamId);
            }
            this.lessonRdy = true;
            if (this.lesson.showTeamChat && tmpShowRight == undefined) {
              this.showRightSide = true;
            }

            this.initAfter();
          }
        } else {
          this.$router.push({
            name: "lmsCourseView",
            params: { id: this.$route.params.cid },
          });
        }
      });
    },
    initAfter() {
      if (this.$route.params.bid > 0 && this.$route.params.iid == 0) {
        this.mode = 1;
        this.initBox(this.$route.params.bid, this.$route.params.bot);
      } else if (
        this.$route.params.bid > 0 &&
        this.$route.params.iid > 0 &&
        (this.$route.params.bot == 6 || this.$route.params.bot == 286)
      ) {
        if (this.lesson.showTeamChat) this.showChatBox = true;
        this.mode = 2;
        this.showAttach(this.$route.params.iid);
        this.initIsDone(this.$route.params.iid);
      } else if (
        this.$route.params.bid > 0 &&
        this.$route.params.iid > 0 &&
        (this.$route.params.bot == 119 ||
          this.$route.params.bot == 122 ||
          this.$route.params.bot == 127 ||
          this.$route.params.bot == 422 ||
          this.$route.params.bot == 435)
      ) {
        if (this.lesson.showTeamChat) this.showChatBox = true;
        this.mode = 3;
        this.showTask(this.$route.params.iid, this.$route.params.bot);
        this.initIsDone(this.$route.params.iid);
      } else if (
        this.$route.params.bid > 0 &&
        this.$route.params.iid > 0 &&
        (this.$route.params.bot == 117 ||
          this.$route.params.bot == 389 ||
          this.$route.params.bot == 416)
      ) {
        if (this.$route.params.bot == 416 || this.$route.params.bot == 389) {
          this.showRightSide = false;
        }
        if (this.$route.params.bot == 117) {
          if (this.lesson.showTeamChat) this.showChatBox = true;
        }
        this.hideFooter = true;
        this.mode = 4;
        this.boxOt = this.$route.params.bot;
      } else {
        if (this.lesson.showTeamChat) this.showChatBox = true;
      }
      this.getScrollHeight();
    },
    initIsDone(id) {
      let _bs = this.lesson.boxes.filter((b) => b.id == this.$route.params.bid);
      if (_bs.length) {
        let _ts = _bs[0].tasks.filter((x) => x.id == id);
        if (_ts.length) {
          if (_ts[0].isCompleted) {
            this.showTaskOrAttachDone = false;
          }
        }
      }
    },
    initBox(boxId, bot) {
      this.boxOt = bot;

      if (bot == 6 || bot == 122 || bot == 117 || bot == 286) {
        if (this.lesson.showTeamChat) this.showChatBox = true;
      }

      if (bot == 6 || bot == 286) {
        this.toggleBodyClass("addClass", "dynamic-locker");
        request({
          api: { method: "GET", url: "Media/boxInAttachmentList" },
          params: {
            id: boxId,
            page: 0,
            size: 100,
            showCompleted: true,
            lessonId: this.$route.params.id,
            courseId: this.$route.params.cid,
            boxId: this.$route.params.bid,
            objectTypeId: this.$route.params.bot,
          },
          store: this.$store,
        }).then((res) => {
          this.toggleBodyClass("removeClass", "dynamic-locker");
          if (res != false) {
            this.boxObj = res.data;
          }
        });
      } else if (
        bot == 119 ||
        bot == 122 ||
        bot == 127 ||
        bot == 422 ||
        bot == 435
      ) {
        this.toggleBodyClass("addClass", "dynamic-locker");
        request({
          api: { method: "POST", url: "taskCore/coreBoxInTaskList" },
          data: {
            id: boxId,
            skip: 0,
            size: 100,

            showCompleted: true,
            lessonId: this.$route.params.id,
            courseId: this.$route.params.cid,
            boxId: this.$route.params.bid,
            objectTypeId: this.$route.params.bot,
          },
          store: this.$store,
        }).then((res) => {
          this.toggleBodyClass("removeClass", "dynamic-locker");
          if (res != false) {
            this.boxObj = res.data;
            this.boxRdy = true;
          }
        });
      } else if (bot == 117 || bot == 416) {
        this.toggleBodyClass("addClass", "dynamic-locker");
        request({
          api: { method: "GET", url: "form/boxInFormList" },
          params: {
            id: boxId,
          },
          store: this.$store,
        }).then((res) => {
          this.toggleBodyClass("removeClass", "dynamic-locker");
          if (res != false) {
            this.boxObj = res.data;
            this.$nextTick(() => {
              this.boxRdy = true;
            });
          }
        });
      }
    },
    showAttach(id) {
      this.boxOt = 6;
      this.filePreview.id = parseInt(id, 10);
      this.filePreview.show = true;
    },
    showTask(id, bot) {
      this.boxOt = bot;

      this.toggleBodyClass("addClass", "dynamic-locker");
      request({
        api: { method: "GET", url: "task/taskInheritedDetail" },
        params: { id: id },
        store: this.$store,
      }).then((res) => {
        this.toggleBodyClass("removeClass", "dynamic-locker");
        if (res != false) {
          this.taskObj.task = res.data.task;
          this.taskObj.rdy = true;
          //}
        }
      });
    },
    showDetailFromOverview(e) {
      this.$router.push({
        name: "lmsLessonView",
        params: {
          id: this.$route.params.id,
          cid: this.$route.params.cid,
          bid: e.box.id,
          iid: e.event.id,
          bot: e.box.ot,
        },
      });
    },
    showDetail(a) {
      this.$router.push({
        name: "lmsLessonView",
        params: {
          id: this.$route.params.id,
          cid: this.$route.params.cid,
          bid: this.$route.params.bid,
          iid: a.id,
          bot: this.$route.params.bot,
        },
      });
    },
    showLesson(id) {
      this.$refs.dnmcnav.openLesson({ id: id });
    },
    onFormFilled(e) {
      let curBox = this.lesson.boxes.filter((x) => x.id == e.boxId);
      if (curBox.length) {
        let curForm = curBox[0].forms.filter((x) => x.id == e.id);
        if (curForm.length) {
          curForm[0].fillingCount = e.fillingCount;
        }
      }
    },
    onReload() {
      this.init();
    },
    lessonNextprev(flag) {
      this.toggleBodyClass("addClass", "dynamic-locker");
      request({
        api: { method: "GET", url: "learn/getNextPrevLesson" },
        params: {
          lessonId: this.$route.params.id,
          courseId: this.$route.params.cid,
          isMobile: this.$store.state.app.isMobile,
        },
        store: this.$store,
      }).then((res) => {
        this.toggleBodyClass("removeClass", "dynamic-locker");
        if (res != false) {
          if (flag == 1) {
            if (res.data.nextLessonId > 0) {
              this.showLesson(res.data.nextLessonId);
            } else {
              Notification.info({
                message: "Сүүлчийн хичээл байна.",
                duration: 5000,
                type: "info",
                position: "top-right",
                offset: 50,
              });
            }
          } else {
            if (res.data.prevLessonId > 0) {
              this.showLesson(res.data.prevLessonId);
            } else {
              Notification.info({
                message: "Эхний хичээл байна.",
                duration: 5000,
                type: "info",
                position: "top-right",
                offset: 50,
              });
            }
          }
        }
      });
    },
    open503() {
      this.courseFinishConfirm.modal = false;

      let _bx503 = this.$refs["dnmcnav"].course.boxes.filter(
        (x) => x.ot == 503
      );
      if (_bx503.length) {
        this.onModalFormFill({
          id: _bx503[0].forms[0]["id"],
          bid: _bx503[0].id,
          bot: 503,
          prms: _bx503[0].forms[0],
        });
      }
    },
    lessonFinish() {
      this.toggleBodyClass("addClass", "dynamic-locker");
      request({
        api: { method: "POST", url: "v2/learn/LessonFinish" },
        params: {
          lessonId: this.$route.params.id,
          courseId: this.$route.params.cid,
          isMobile: this.$store.state.app.isMobile,
        },
        store: this.$store,
      }).then((res) => {
        this.toggleBodyClass("removeClass", "dynamic-locker");
        if (res != false) {
          this.lessonFinishConfirm = false;
          request({
            api: { method: "get", url: "v2/learn/courseDetail" },
            params: {
              id: this.$route.params.cid,
            },
            store: this.$store,
          }).then((resC) => {
            this.toggleBodyClass("removeClass", "dynamic-locker");
            if (resC != false) {
              this.$refs["dnmcnav"].completeLesson();
              if (resC.data.course.percent == 100) {
                this.init();
                let ratingSurvey = resC.data.course.alerts.filter(
                  (x) => x.type == 503
                );
                if (ratingSurvey.length > 0) {
                  this.courseFinishConfirm.hasRatingSurvey = true;
                }
                this.courseFinishConfirm.modal = true;
              } else {
                if (res.data.nextLessonId > 0) {
                  this.prevOrNextContent(1, resC.data.course.percent);
                } else {
                  Notification({
                    title: "Мэдэгдэл",
                    message:
                      "Та сургалтын сүүлийн хичээлийг дуусгалаа. Үзэж дуусгаагүй хичээлүүдээ дуусгана уу.",
                    type: "warning",
                  });
                  this.$router.push({
                    name: "lmsCourseView",
                    params: {
                      id: this.$route.params.cid,
                      bid: 0,
                      iid: 0,
                      bot: 0,
                    },
                  });
                }
              }
            }
          });
        }
      });
    },
    prevOrNextContent(m, prcnt) {
      if (prcnt != undefined) {
        this.$refs["dnmcnav"].prevOrNextContent({
          mode: m,
          params: this.$route.params,
          percent: prcnt,
        });
      } else {
        this.$refs["dnmcnav"].prevOrNextContent({
          mode: m,
          params: this.$route.params,
        });
      }
    },
    onFileLoaded(e) {
      this.fileInf = {
        obj: e,
        ready: true,
      };
    },
    onRated(e) {
      this.fileInf.obj.myRate = e.rate;
      this.fileInf.obj.rateAvg = e.avg;
    },
    contentNoPadding(e) {
      this.cntntNoPdn = e;
    },
    onHideFinish() {
      this.showTaskOrAttachDone = false;
    },
    onFinishForm() {
      this.markAsCompleteItem();
    },
    onFinishVideo() {
      this.markAsCompleteItem();
    },
    downloadAttachment() {
      window.open(
        this.fileInf.obj.link + "?i=" + Math.floor(Math.random() * 100),
        "_blank"
      );
    },
    attachOnFinished(e) {},
    onCompletedInfo(e) {
      if (e) {
        let _b = this.lesson.boxes.filter(
          (x) => x.id == this.$route.params.bid
        );
        let itms = "";
        if (_b.length) {
          if (_b[0].attaches.length) {
            itms = "attaches";
          } else if (_b[0].tasks.length) {
            itms = "tasks";
          }

          _b[0][itms].filter(
            (x) => x.id == this.$route.params.iid
          )[0].isCompleted = true;
        }
      }
      this.showTaskOrAttachDone = !e;
    },
    markAsCompleteItem() {
      this.toggleBodyClass("addClass", "dynamic-locker");
      let _url = "Learn/AttachFinish";
      let fieldName = "attachId";
      if (this.$route.params.bot != 6 && this.$route.params.bot != 286) {
        _url = "Learn/TaskFinish";
        fieldName = "taskId";
      } else {
        fieldName = "attachId";
      }
      if (this.$route.params.bot != 389) {
        request({
          api: { method: "POST", url: _url },
          data: {
            [fieldName]: this.$route.params.iid,
            lessonId: this.$route.params.id,
            courseId: this.$route.params.cid,
            boxId: this.$route.params.bid,
            objectTypeId: this.$route.params.bot,
            isCompleted: true,
          },
          store: this.$store,
        }).then((res) => {
          this.toggleBodyClass("removeClass", "dynamic-locker");
          if (res != false) {
            this.onCompletedInfo(true);
            this.updateLessonPercent();
          }
        });
      } else {
        this.updateLessonPercent();
      }
    },
    updateLessonPercent() {
      this.toggleBodyClass("addClass", "dynamic-locker");
      request({
        api: { method: "GET", url: "learn/LessonPercent" },
        params: {
          id: this.$route.params.id,
          cid: this.$route.params.cid,
        },
        store: this.$store,
      }).then((res) => {
        this.toggleBodyClass("removeClass", "dynamic-locker");
        if (res != false) {
          this.navDynamicUpdate(res.data.percent);
          this.lesson.percent = res.data.percent;
          if (this.lesson.percent == 100) {
            this.lessonFinishConfirm = true;
          } else {
            this.prevOrNextContent(1);
          }
        }
      });
    },
    backToCourse() {
      this.$router.push({
        name: "lmsCourseView",
        params: { id: this.$route.params.cid, bid: 0, iid: 0, bot: 0 },
      });
    },
    onAttach(e) {
      this.fileSidebar.id = parseInt(e, 10);
      this.fileSidebar.show = true;
    },
    fileSidebarClosed() {
      this.fileSidebar.show = false;
      this.fileSidebar.id = 0;

      if (this.fileSidebar.fromInteractive) {
        this.fileSidebar.fromInteractive = false;
        this.$refs.mediaMainPreview.playerResume();
      }
    },
    navDynamicUpdate(e) {
      this.$refs.dnmcnav.updateCompleted(e);
    },
    updateResultCount(e) {
      request({
        api: { method: "GET", url: "V2/form/finishedResultCount" },
        params: {
          formId: e,
          courseId: this.$route.params.cid,
          lessonId: this.$route.params.id,
          boxId: this.$route.params.bid,
          objectTypeId: this.$route.params.bot,
        },
        store: this.$store,
      }).then((res) => {
        if (res != false) {
          this.$refs.frmFill.prms.resultCount = res.data.resultCount;
          this.$refs.frmFill.showLessonExamResult();
        }
      });
    },
    sendObjTitle() {
      let rv = "";

      if (this.$route.params.iid > 0) {
        rv =
          this.lesson.boxes.filter((b) => b.id == this.$route.params.bid)[0]
            .nm +
          " > " +
          this.getBreadcrumbTitle();
      } else if (
        this.$route.params.bid > 0 &&
        this.lesson.boxes.filter((b) => b.id == this.$route.params.bid).length
      ) {
        rv =
          this.lesson.name +
          " > " +
          this.lesson.boxes.filter((b) => b.id == this.$route.params.bid)[0].nm;
      } else {
        rv = this.lesson.name;
      }

      return rv;
    },
    getScrollHeight() {
      let mh = 170;
      if (screen.width <= 1024) {
        mh = 110;
      }
      if (this.mode == 4 && this.$store.state.app.isMobile) {
        mh = 55;
      } else if (this.mode == 4) {
        mh = 115;
      }

      if (this.$store.state.app.mainLayoutConfig.expanded) {
        mh = 0;
      }
      this.scrollHeight = window.innerHeight - mh;
    },
    toggleContent(e) {},
    lessonExamStarted(e) {
      if (e) {
        this.expanded = false;
      } else {
        this.expanded = true;
      }
    },
    onRebuy(lesson) {
      this.reBuyObj = lesson;
      this.reBuyModal = true;
    },

    showInteractiveMedia(e) {
      this.fileSidebar.fromInteractive = true;
      this.onAttach(e);
    },
    showInteractiveHtml(e) {
      this.fileSidebar.fromInteractive = true;
      this.htmlObj.html = e;
      this.htmlObj.modal = true;
    },
    onHideHtmlObj() {
      this.fileSidebar.fromInteractive = false;
      this.htmlObj.modal = false;
      this.$refs.mediaMainPreview.playerResume();
    },
  },
  watch: {
    "$root.$route"(newRoute) {
      if (newRoute.params.bot != 416 && this.$refs.frmFill != undefined) {
        this.$refs.frmFill.forceInterval();
        this.fillingFormKey++;
      }
      let _tmp = this.$data.expanded;
      let _tmpRight = this.$data.showRightSide;
      Object.assign(this.$data, this.$options.data());
      this.$data.expanded = _tmp;
      this.$data.showRightSide = _tmpRight;
      this.$nextTick(() => {
        //this.toggleNavbar(false);
        this.init(_tmpRight);
        this.getScrollHeight();
      });
    },
  },
};
</script>
